import { Fragment } from 'react';
import Rutas from './componentes/Rutas/Rutas';

function App() {
  return (
    <Fragment>
      <Rutas/>
      
    </Fragment>
  );
}

export default App;
